import type { AccountKey } from 'owa-client-types';
import { OcpsPoliciesFetchState } from '../store/schema/OutlookCloudPoliciesSchema';
import getStore from '../store/store';

export function getAccountFetchState(accountKey: AccountKey): OcpsPoliciesFetchState {
    return getStore().get(accountKey)?.fetchState ?? OcpsPoliciesFetchState.NotStarted;
}
